<div class="panelPopup">
<div mat-dialog-title class="titlePanel">
    <label>Fechas de Reporte</label> 
</div>
<div mat-dialog-content>
<form [formGroup]="formGroup" fxLayout="column" xLayoutAlign="space-around none" >
 <div class="row">
  <label for="picker">Desde:</label>
  <mat-form-field appearance="fill" color="accent" class="calendar"  fxLayout="column" xLayoutAlign="space-around none">
    <input matInput [matDatepicker]="picker" (click)="picker.open()" (dateInput)="limteFecha($event)" formControlName="initialDate" placeholder="Fecha Inicial"  [max]="maxStartDate" [min]="minStartDate">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>
<div class="row">
  <label for="picker2">Hasta:</label>
  <mat-form-field appearance="fill" color="accent" class="calendar"  fxLayout="column" xLayoutAlign="space-around none">
    <input matInput [matDatepicker]="picker2" (click)="picker2.open()" formControlName="finalDate" placeholder="Fecha Final" [min]="minEndDate" [max]="maxEndDate">
    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
    <mat-datepicker #picker2></mat-datepicker>
  </mat-form-field>
</div>
</form>

</div>
<div mat-dialog-actions align="end">
<button mat-button (click)="cancel()">Cerrar</button>
<button mat-button (click)="accept()" class="btnAccept">Descargar</button>
</div>
</div>



